import PovahaPripomienky from '../../../../model/pripomienka/PovahaPripomienky';
import StavPripomienky from '../../../../model/pripomienka/StavPripomienky';
import SaveAdminPripomienka from '../../../../model/pripomienka/SaveAdminPripomienka';
import ClassType from '../../../../model/pripomienka/ClassType';

export default (classType: ClassType): SaveAdminPripomienka => (
  {
    pripomienkujuciSubjekt: null,
    pripomienkovatel: null,
    datumVytvorenia: new Date(),
    clanok: '',
    paragraf: '',
    odsek: '',
    celyMaterial: false,
    ine: '',
    text: '',
    odoslana: false,
    povahaPripomienky: classType === ClassType.HROMADNA_PRIPOMIENKA
      ? PovahaPripomienky.OBYCAJNA : null,
    priradeny: null,
    vyhodnotil: null,
    zasadna: false,
    stavPripomienky: StavPripomienky.NESPRACOVANA,
    textVyhodnotenia: null,
  });
